var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.529,
    height: 23.549,
    viewBox: "0 0 38.529 23.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(-6335.319 -6761.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1186",
    "data-name": "Rectangle 1186",
    transform: "translate(6336.319 6762.739)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.529,
    height: 21.549,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 37.529,
    height: 22.549,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1083-2",
    "data-name": "Group 1083"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1187",
    "data-name": "Rectangle 1187",
    width: 17.462,
    height: 2.161,
    rx: 1.081,
    transform: "translate(6354.583 6766.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 17.462,
    height: 2.161,
    rx: 1.081,
    transform: "translate(6354.583 6772.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 17.462,
    height: 2.161,
    rx: 1.081,
    transform: "translate(6354.583 6778.495)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a02dfc69be13291199b39906b2abd737",
    d: "M6344.694,6772.611a2.753,2.753,0,1,0-2.7-2.8h0v.05a2.736,2.736,0,0,0,2.7,2.753Zm0,2.019c-2.118,0-6.308,1.055-6.308,3.212v3.991h12.744v-3.991c0-2.157-4.318-3.212-6.436-3.212Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1190",
    "data-name": "Rectangle 1190",
    transform: "translate(6338.386 6765.195)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.744,
    height: 16.584,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 13.744,
    height: 17.584,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetting);
export default __webpack_public_path__ + "static/media/profile_setting.5561a87d82f0540577d9829aad7dbd43.svg";
export { ForwardRef as ReactComponent };